import { API_ANALYSIS, API_UTM, API_UTM_ADD_TRACKING, API_UTM_ANALYSIS_DOWNLOAD, API_UTM_DOWNLOAD } from 'config'
import Api from 'services/api'

export const getUtmLogs = (filterData: Record<string, any>) => {
  return Api.get(API_UTM, filterData)
}

export const getUtmAnalysis = (filterData: Record<string, any>) => {
  return Api.get(API_ANALYSIS, filterData)
}

export const downloadUtmLogs = () => {
  return Api.post(
    API_UTM_DOWNLOAD,
    {},
    {},
    {
      responseType: 'blob',
      timeout: 300000,
    },
  )
}

export const downloadUtmAnalysis = () => {
  return Api.post(
    API_UTM_ANALYSIS_DOWNLOAD,
    {},
    {},
    {
      responseType: 'blob',
      timeout: 300000,
    },
  )
}

export const addUtmTracking = (pageName: string, data: Record<string, any>) => {
  return Api.post(API_UTM_ADD_TRACKING, data, { pageName })
}
